export default "__VITE_ASSET__D0ra_4uM__"